import { render, staticRenderFns } from "./TargetingClickTo.vue?vue&type=template&id=2c3bb3b4&"
import script from "./TargetingClickTo.vue?vue&type=script&lang=js&"
export * from "./TargetingClickTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports